class MobileDock extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const header = document.querySelector('.shopify-section-header');

    this.isAction = false;
    this.scrollY  = header ? parseInt(header.getBoundingClientRect().bottom) : 0;

    if (Shopify && Shopify.designMode) {
      this.scrollY = 0;
    }

    this.querySelectorAll('.dock__item[data-action]').forEach((button) => {
      button.addEventListener('click', this.onButtonClick.bind(this));
    });
    this.shopMenu = document.getElementById(this.querySelector('[data-action="shop-menu"]')?.getAttribute('aria-controls'));
    this.shopMenu?.querySelectorAll('[data-shop-menu-close]').forEach((button) => {
      button.addEventListener('click', this.closeShopMenu.bind(this));
    });
    this.onKeydownHandler = this.onKeydown.bind(this);
    document.addEventListener('keydown', this.onKeydownHandler);
    if (/shopifypreview\.com$/i.test(window.location.hostname)) {
      document.documentElement.classList.add('tomokagu-shopify-preview');
    }
    document.addEventListener('menudrawer:close', this.hideStickyHeader.bind(this));
    document.addEventListener('searchmodal:close', this.hideStickyHeader.bind(this));

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.onScrollHandler();

    this.updateDockHeight = () => {
      if (this.offsetHeight > 0) {
        document.documentElement.style.setProperty('--mobile-dock-height', `${this.offsetHeight}px`);
      }
    };
    requestAnimationFrame(this.updateDockHeight);
    this.dockResizeObserver = new ResizeObserver(this.updateDockHeight);
    this.dockResizeObserver.observe(this);
    document.addEventListener('matchSmall', () => {
      requestAnimationFrame(this.updateDockHeight);
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScrollHandler);
    document.removeEventListener('keydown', this.onKeydownHandler);
    this.dockResizeObserver?.disconnect();
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop >= this.scrollY) {
      this.classList.add('is-active');
    }
    else {
      this.classList.remove('is-active');
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const delay = 0;

    switch (target.dataset.action) {
      case 'cart':
        this.isAction = true;

        const miniCart = document.querySelector('mini-cart');
        if (miniCart) {
          setTimeout(() => {
            miniCart.open();
            document.activeElement.blur();
          }, delay);
        }
        else {
          window.location.href = window.routes.cart_url;
        }
        break;

      case 'menu':
        this.isAction = true;

        const headerDrawer = document.querySelector('header-drawer');
        if (headerDrawer) {
          setTimeout(() => {
            headerDrawer.openMenuDrawer();
          }, delay);
        }
        break;

      case 'search':
        this.isAction = true;
        window.location.assign(target.href || window.routes.search_url);
        break;

      case 'shop-menu':
        if (!this.shopMenu) {
          window.location.href = target.href;
          return;
        }
        this.openShopMenu(target);
        break;
    }
  }

  async openSearch(fallbackUrl) {
    const searchUrl = fallbackUrl || window.routes.search_url;

    try {
      if (window.customElements && window.customElements.whenDefined) {
        await Promise.race([
          window.customElements.whenDefined('search-modal'),
          new Promise((resolve) => window.setTimeout(resolve, 800))
        ]);
      }

      const searchModal = Array.from(document.querySelectorAll('search-modal')).find((modal) => {
        const style = window.getComputedStyle(modal);
        const trigger = modal.querySelector('summary');
        return style.display !== 'none'
          && style.visibility !== 'hidden'
          && modal.getClientRects().length > 0
          && trigger
          && trigger.getClientRects().length > 0;
      });

      if (!searchModal || typeof searchModal.open !== 'function') {
        window.location.assign(searchUrl);
        return;
      }

      searchModal.open();
      window.requestAnimationFrame(() => {
        searchModal.querySelector('input:not([type="hidden"])')?.focus();
      });
    }
    catch (error) {
      console.warn('Unable to open the mobile search modal; using the search page instead.', error);
      window.location.assign(searchUrl);
    }
  }

  openShopMenu(trigger) {
    this.shopMenuTrigger = trigger;
    this.shopMenu.hidden = false;
    requestAnimationFrame(() => this.shopMenu.classList.add('is-open'));
    document.documentElement.classList.add('mobile-shop-menu-open');
    trigger.setAttribute('aria-expanded', 'true');
    this.shopMenu.querySelector('[data-shop-menu-close]')?.focus();
  }

  closeShopMenu() {
    if (!this.shopMenu || this.shopMenu.hidden) return;
    this.shopMenu.classList.remove('is-open');
    document.documentElement.classList.remove('mobile-shop-menu-open');
    this.shopMenuTrigger?.setAttribute('aria-expanded', 'false');
    window.setTimeout(() => {
      this.shopMenu.hidden = true;
      this.shopMenuTrigger?.focus();
    }, 250);
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.closeShopMenu();
  }

  hideStickyHeader() {
    const header = document.querySelector('sticky-header');
    if (header === null) return;

    if (theme.config.mqlSmall && this.isAction && header.sticky()) {
      setTimeout(() => {
        header.hide();
        this.isAction = false;
      }, 500);
    }
  }

  waitStickyHeader() {
    const header = document.querySelector('sticky-header');
    if (header === null) return;

    if (!header.sticky() && !this.isElementVisible(header)) {
      header.hide();
      setTimeout(() => header.reveal());

      return 250;
    }

    return 0;
  }

  isElementVisible(element) {
    const rect = element.getBoundingClientRect(),
        width  = window.innerWidth || document.documentElement.clientWidth,
        height = window.innerHeight || document.documentElement.clientHeight,
        efp    = function (x, y) { return document.elementFromPoint(x, y) };

    // Return false if it's not in the viewport
    if (rect.right < 0 || rect.bottom < 0 || rect.left > width || rect.top > height) {
      return false;
    }

    // Return true if any of its four corners are visible
    return (
      element.contains(efp(rect.left,  rect.top))
      || element.contains(efp(rect.right, rect.top))
      || element.contains(efp(rect.right, rect.bottom))
      || element.contains(efp(rect.left,  rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.top))
      || element.parentNode.contains(efp(rect.right, rect.top))
      || element.parentNode.contains(efp(rect.right, rect.bottom))
      || element.parentNode.contains(efp(rect.left,  rect.bottom))
    );
  }
}
customElements.define('mobile-dock', MobileDock);
